import { getStore } from "@/utils/store";

export function getToken() {
  let info = getStore({ name: "unionToken", type: true });
  // 返回值这块可能需要修改
  return info;
}

export function getOIDCToken() {
  let info = getStore({ name: "OIDCToken", type: true });
  // 返回值这块可能需要修改
  return info;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js